import * as fromDatatype from '../../../../../models/datatype-library';

export class PmtStmtIntPoLinkDto {
    guid: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    doc_remarks: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  }
  